import { apiFetch } from "../utils/apiFetch"

export function searchEuipoPersons(query: string) {
  if (!query.trim()) return Promise.resolve([])

  return apiFetch(
    `/api/euipo/persons/search?q=${encodeURIComponent(query)}`
  )
}

export function getEuipoApplicantDetails(personId: string) {
  if (!personId) {
    throw new Error("personId is required")
  }

  return apiFetch(
    `/api/euipo/persons/${personId}`
  )
}
